import { Button, FormControl, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'
import { Search } from 'react-feather'

export const FilterPayments = ({ useFetchInit }) => {

  const {
    FetchData,
    Actions,
    Forms
  } = useFetchInit

  const {
    handleClickSearchPayments,
    handleKeyDown,
    handleClickFechtVehicleCredits,
    handleChangeCredit,
    handleClickSearchPendientes
  } = Actions

  const { FormRequestGlobal: { formState, onInputChange } } = Forms

  const { fetchAllVehicleCredits: { vehicleCredits } } = FetchData

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2, mb: 1 }}>
        <FormControl fullWidth>
          <label htmlFor="identificador">IDENTIFICADOR DE CREDITO</label>
          <TextField
            id='identificador'
            name='identificador'
            value={formState.identificador}
            onChange={onInputChange}
            size='small'
            placeholder='IDENTIFICADOR DE CREDITO EJ. CRED1XX'
            type='text'
            variant={'outlined'}
            onKeyDown={handleKeyDown}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="serch"
                    onClick={() => { handleClickSearchPayments() }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </FormControl>
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>

        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mt: 1, mb: 1 }}>
          <FormControl fullWidth>

            <label htmlFor="nombre">Nombre del cliente</label>
            <TextField
              id='nombre'
              name='nombre'
              value={formState.nombre}
              onChange={onInputChange}
              size='small'
              placeholder='Nombre'
              type='text'
              variant={'outlined'}
              // onKeyDown={handleKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="serch"
                      onClick={() => { handleClickFechtVehicleCredits("nombre", `%${formState.nombre}%`) }}
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mt: 1, mb: 1 }}>
          <FormControl fullWidth>
            <label htmlFor="dpi">DPI del cliente</label>
            <TextField
              id='dpi'
              name='dpi'
              value={formState.dpi}
              onChange={onInputChange}
              size='small'
              placeholder='Nombre'
              type='text'
              variant={'outlined'}
              // onKeyDown={handleKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="serch"
                      onClick={() => { handleClickFechtVehicleCredits("dpi", `%${formState.dpi}%`) }}
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={3} lg={3} sx={{ mt: 1, mb: 1 }}>
          <FormControl fullWidth>
            <label htmlFor="telefono">Telefono</label>
            <TextField
              id='telefono'
              name='telefono'
              value={formState.telefono}
              onChange={onInputChange}
              size='small'
              placeholder='Telefono'
              type='text'
              variant={'outlined'}
              // onKeyDown={handleKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="serch"
                      onClick={() => { handleClickFechtVehicleCredits("celular_1", `%${formState.telefono}%`) }}
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={5} lg={5} sx={{ mt: 1, mb: 1 }}>
          <FormControl fullWidth>
            <label htmlFor="email">Correo electronico</label>
            <TextField
              id='email'
              name='email'
              value={formState.email}
              onChange={onInputChange}
              size='small'
              placeholder='Correo electronico'
              type='email'
              variant={'outlined'}
              // onKeyDown={handleKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="serch"
                      onClick={() => { handleClickFechtVehicleCredits("correo", `%${formState.email}%`) }}
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>
        </Grid>


        <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mt: 1, mb: 1 }}>
          <FormControl fullWidth>
            <label htmlFor="direccion">Direccion</label>
            <TextField
              id='direccion'
              name='direccion'
              value={formState.direccion}
              onChange={onInputChange}
              size='small'
              placeholder='Direccion'
              type='text'
              variant={'outlined'}
              // onKeyDown={handleKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="serch"
                      onClick={() => { handleClickFechtVehicleCredits("direccion", `%${formState.direccion}%`) }}
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2, mb: 1 }}>
          <FormControl fullWidth>
            <label htmlFor="idcredito">* Credito</label>
            <CustomAutocomplete
              customId="idcredito"
              customName="idcredito"
              customValue={formState.idcredito}
              customOnChange={(target, value) => handleChangeCredit(value)}
              customPlaceholder='Seleccionar un credito'
              customOptions={
                vehicleCredits && vehicleCredits.length > 0
                  ? vehicleCredits.map(({ idcredito, nombre, correo, dpi }) => ({
                    value: idcredito,
                    name: `Cliente: ${nombre} - ${dpi}, Credito: CRED${idcredito}`
                  }))
                  : []
              }
              customDisableClearable={true}
            />
          </FormControl>
        </Grid>



      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2, mb: 5, textAlign: 'center' }}>
        <Button
          startIcon={<Search />}
          variant="contained"
          type="button"
          className='btn-round'
          color='success'
          onClick={handleClickSearchPendientes}
          sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
        >
          Pendientes de aprobacion
        </Button>
      </Grid>


    </>
  )
}
